<template>
  <div v-if="!isLoading" id="g-contents" class="kbo player-wrap" >
    <highlight-player :highlight-info="highlightInfo"></highlight-player>
    <div class="player-nav">
      <ul>
        <li>
          <a class="on">추천</a>
        </li>
      </ul>
    </div>
    <highlight-recommend-list :current-content-id="contentId"></highlight-recommend-list>
  </div>
</template>

<script>
  import HighlightPlayer from '@/components/player/baseball/HighlightPlayer'
  import HighlightRecommendList from '@/components/player/baseball/HighlightRecommendList'
  import { getHighlightContents } from '@/common/utils/request'
  import { showLoginPopup } from '@/common/utils/scalable.player'
  import { destroyPlayer } from '@/common/utils/common'

  import _ from 'lodash'
  import { setReferer } from '@/common/utils/referer'
  import constant from '@/common/resources/constant'
  export default {
    name: 'highlight',
    components: {
      HighlightRecommendList,
      HighlightPlayer
    },
    data () {
      return {
        isLoading: true,
        contentId: '',
        highlightInfo: {}
      }
    },
    methods: {
      async fetchData () {
        try {
          return await getHighlightContents({ contentId: this.contentId })
        } catch (err) {
          alert(constant.MSG_COMMON_ERROR)
        }
      },
      setData (response) {
        this.highlightInfo = _.get(response, 'data', {})
      },
      async init () {
        setReferer(this.$route.fullPath)
        this.isLoading = true
        this.contentId = _.get(this.$route, 'query.contentid', '')
        const response = await this.fetchData()
        this.setData(response)
        this.setPlayerEvent()
        this.isLoading = false
      },
      setPlayerEvent () {
        window.showLoginLayout = showLoginPopup
      }
    },
    mounted () {
      // destroyPlayer()
    },
    created () {
      this.init()
    },
    beforeDestroy () {
      destroyPlayer()
    },
    watch: {
      $route () {
        this.init()
      }
    }
  }
</script>
<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/vod.css"></style>
<style lang="css" src="@/assets/css/kbo.css"></style>
